<script setup lang="ts">
interface Props {
  firstName: string;
  lastName: string;
}

interface Emits {
  (e: 'update:firstName', value: string): void;
  (e: 'update:lastName', value: string): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="space-y-5">
    <div>
      <label for="firstName" class="block text-sm text-[#F5F0EA] mb-2">
        {{ $t('signup_step_profile.first_name_label') }}
      </label>
      <input
        type="text"
        id="firstName"
        required
        :value="firstName"
        @input="emit('update:firstName', ($event.target as HTMLInputElement).value)"
        class="w-full px-4 py-3 bg-[#18181C] border border-[#2A2018] rounded-2xl focus:bg-[#1E1E23] focus:ring-2 focus:ring-[#D4956A] focus:border-transparent outline-none transition text-[#F5F0EA] placeholder:text-[#524840]"
        :placeholder="$t('signup_step_profile.first_name_placeholder')"
      />
    </div>
    <div>
      <label for="lastName" class="block text-sm text-[#F5F0EA] mb-2">
        {{ $t('signup_step_profile.last_name_label') }}
      </label>
      <input
        type="text"
        id="lastName"
        required
        :value="lastName"
        @input="emit('update:lastName', ($event.target as HTMLInputElement).value)"
        class="w-full px-4 py-3 bg-[#18181C] border border-[#2A2018] rounded-2xl focus:bg-[#1E1E23] focus:ring-2 focus:ring-[#D4956A] focus:border-transparent outline-none transition text-[#F5F0EA] placeholder:text-[#524840]"
        :placeholder="$t('signup_step_profile.last_name_placeholder')"
      />
    </div>
  </div>
</template>
